import { render, staticRenderFns } from "./IdentityVerificationPage.vue?vue&type=template&id=fc9ef0bc&scoped=true&"
import script from "./IdentityVerificationPage.vue?vue&type=script&lang=js&"
export * from "./IdentityVerificationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9ef0bc",
  null
  
)

export default component.exports